export enum Platform {
  IOS = 'ios',
  ANDROID = 'android',
  WEB = 'web'
}
